export default __webpack_public_path__ + "static/media/city.195f2e15.svg";